import { Location } from '@cobliteam/common-types';

import { lazy } from '@cobliteam/lazy-with-retries';

const IntegrationsAppsPage = lazy(() => import('@cobliteam/integrations/src/components/Apps/AppsPage'));
const IntegrationsApisPage = lazy(() => import('@cobliteam/integrations/src/components/Apis/ApisPage'));
const IntegrationsWebhooksPage = lazy(() => import('@cobliteam/integrations/src/components/Webhooks/WebhooksPage'));

const routes = [
  {
    path: Location.APPS,
    featureFlag: 'integrationsPage',
    component: IntegrationsAppsPage,
    accessDeniedDescription: 'ver integrações com a Cobli',
  },
  {
    path: Location.APIS,
    featureFlag: 'integrationsPage',
    component: IntegrationsApisPage,
    accessDeniedDescription: 'ver integrações com a Cobli',
  },
  {
    path: Location.WEBHOOKS,
    featureFlag: 'integrationsPage',
    component: IntegrationsWebhooksPage,
    accessDeniedDescription: 'ver integrações com a Cobli',
  },
];

export default routes;
